import { Injectable } from '@angular/core';

import { tap, Observable, merge } from 'rxjs';

import { WebSocketEventsEnum } from '@shared/websocket';
import { User } from '@shared/user/models';
import {
  AccountApiService,
  SocketService,
  UsersQuery,
  UsersStore,
} from '@tablesready/frontend-store';

@Injectable({providedIn: 'root'})
export class UsersService {
  constructor(
    private readonly store: UsersStore,
    private readonly query: UsersQuery,
    private readonly socketService: SocketService,
    private readonly accountApiService: AccountApiService,
  ) {}

  load(): Observable<User[]> {
    return this.accountApiService.getUsers()
      .pipe(tap(users => this.store.set(users)));
  }

  reset(): void {
    this.store.reset();
  }

  selectAll(): Observable<User[]> {
    return this.query.selectAll();
  }

  listenToChanges() {
    return merge(
      this.socketService.getEventStream<User>(WebSocketEventsEnum.userCreated)
        .pipe(tap(user => this.store.add(user))),
      this.socketService.getEventStream<User>(WebSocketEventsEnum.userUpdated)
        .pipe(tap(user => this.store.update(user._id, user))),
      this.socketService.getEventStream<string[]>(WebSocketEventsEnum.userDeleted)
        .pipe(tap(ids => this.store.remove(ids))),
    );
  }
}
